import styled from '@emotion/styled';

import { Modal } from '@/design-system';

import { ReceiveAddress } from './receive-address';
import { ReceiveFees } from './receive-fees';
import { ReceiveNetworkSelection } from './receive-network-selection';
import { ReceiveFlowProps } from './types';

const MODAL_WIDTH = 600;
const MODAL_GAP = 16;

const PageFlow = styled('section')(({ theme: t }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  minWidth: 0,
  minHeight: 559,
  gap: t.spacing[16],
}));

export const ReceiveFlow = ({
  presentation,
  open,
  onClose,
  coin,
  suiAddress,
  selectedChainId,
  onChainChange,
  chainAddresses,
  bridgeFees,
}: ReceiveFlowProps) => {
  const symbol = coin?.symbol ?? (presentation === 'page' ? 'SUI' : 'crypto');
  const activeChainId = selectedChainId === undefined ? 'sui' : selectedChainId;
  const addresses = { sui: suiAddress, ...chainAddresses };
  const content = activeChainId ? (
    <>
      <ReceiveAddress symbol={symbol} chainId={activeChainId} address={addresses[activeChainId]} />
      {bridgeFees && activeChainId !== 'sui' && <ReceiveFees fees={bridgeFees} />}
    </>
  ) : (
    <ReceiveNetworkSelection symbol={symbol} onChainChange={onChainChange} />
  );
  if (presentation === 'page')
    return <PageFlow aria-label={`Receive ${symbol}`}>{content}</PageFlow>;
  return (
    <Modal
      open={open}
      onOpenChange={(next) => {
        if (!next) onClose();
      }}
      title={coin ? `Receive ${coin.symbol}` : 'Receive crypto assets'}
      showBackIcon
      onBack={onClose}
      maxWidth={MODAL_WIDTH}
      gap={MODAL_GAP}
      contentPadding={0}
    >
      {content}
    </Modal>
  );
};
